import { render, staticRenderFns } from "./FinishTab.vue?vue&type=template&id=05a6c636"
import script from "./FinishTab.vue?vue&type=script&lang=js"
export * from "./FinishTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports